import { useLanguage } from '../../i18n/LanguageContext'

const BIT_LINK = 'https://www.bitpay.co.il/app/me/AA6C7F62-705B-E013-1B58-A1A8175A2F9B197A'

export function DonateCard() {
  const { t } = useLanguage()

  return (
    <div className="glass p-5 text-center animate-fade-in-up">
      <p className="text-slate-300 text-sm mb-3">
        {t('donate.cardPrompt') as string} ☕
      </p>
      <a
        href={BIT_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 bg-[#3C50FA] hover:bg-[#2E42E0] text-white font-bold py-3 px-6 rounded-full transition-colors text-base"
      >
        {t('donate.bit') as string}
      </a>
    </div>
  )
}
